import {FIELD_REQUIRED} from '@constants/messages';

export const validateMultipleInput = (value) => {
    if (!value) {
        return FIELD_REQUIRED;
    }
};
